<template>
  <Catalog
    title="Тип расхода объекта"
    name-label="Название"
    description-label="Например: Подбор персонала"
    submit-error="Укажите название расхода объекта."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "LocationCostType",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getLocationCostTypeById(id);
    },
    async putData(data) {
      return await this.putLocationCostType(data)
    },
    async postData(data) {
      return await this.postLocationCostType(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LocationCostTypes/LocationCostType.vue